import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type LoginBackgroundProps = {
  children: ReactNode;
  className?: string;
};

export function LoginBackground({ children, className }: LoginBackgroundProps) {
  return (
    <main
      className={cn(
        "relative flex min-h-screen items-center justify-center overflow-hidden bg-[var(--color-brand-primary-dark)] px-4 py-8",
        className,
      )}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-70 [background-image:linear-gradient(rgba(220,234,240,0.12)_1px,transparent_1px),linear-gradient(90deg,rgba(220,234,240,0.12)_1px,transparent_1px)] [background-size:48px_48px]"
      />
      {children}
    </main>
  );
}
